import RequestAbstract from "../abstract";

export default class PublicTgSessionChats extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-tg-session-chats";
    }

}
